import React from 'react';

const Procesos = () => {
  const tiposDeOnda = [
    {
      image: '/imgs/procesos-e.png',
      title: 'Onda E (1,0 a 1,8mm)'
    },
    {
      image: '/imgs/procesos-b.png',
      title: 'Onda B (2.1 a 3.00mm)'
    },
    {
      image: '/imgs/procesos-c-300x83.png',
      title: 'Onda C (3,2 a 3,9mm)'
    },
    {
      image: '/imgs/procesos-doble-300x78.png',
      title: 'Doble Triple (E/C)'
    }
  ];

  return (
    <section 
      id="procesos" 
      className="section procesos"
      style={{
        backgroundImage: 'url(/imgs/procesos-background-Plegadora1.jpg)'
      }}
    >
      <div className="procesos-container">
        <div className="procesos-tech">
          <h2 className="procesos-tech-title">Especificaciones Técnicas</h2>
          <div className="procesos-tech-text">
            <div className="procesos-tech-item">
              <h3>Impresión</h3>
              <p>
                Flexo: cajas de 145x260 cm a 2/4 colores, Slotter.<br/>
                Offset: Cajas de microcorrugado / cartulina en formato 100x140 cm
              </p>
            </div>
            <div className="procesos-tech-item">
              <h3>Terminación</h3>
              <p>
                Barniz, laca UV y laca UV sectorizada, polipropileno brillante y polipropileno mate.
              </p>
            </div>
            <div className="procesos-tech-item">
              <h3>Capacidad</h3>
              <p>
                Nuestra planta es una de las de mayor capacidad del país.<br/>
                Trabajamos 7x24, cumpliendo plazos de menos de 7 días.
              </p>
            </div>
          </div>
        </div>
        <div className="procesos-content">
          <div className="procesos-main-image">
            <img 
              src="/imgs/procesos-Procesode-Fabricacion-de-Carton-Corrugado.jpg" 
              alt="Proceso de Fabricación de Cartón Corrugado"
              className="procesos-large-image"
            />
            <h3 className="procesos-image-title">Cartón Corrugado</h3>
          </div>

          <div className="procesos-ondas-section">
            <h3 className="procesos-ondas-title">Tipos de Onda:</h3>
            <div className="procesos-ondas-grid">
              {tiposDeOnda.map((onda, index) => (
                <div key={index} className="procesos-onda-item">
                  <img 
                    src={onda.image} 
                    alt={onda.title}
                    className="procesos-onda-image"
                  />
                  <p className="procesos-onda-title">{onda.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Procesos;
